import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider, facebookProvider, appleProvider } from "../utils/firebase";
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { consumePostAuthRedirect } from "../utils/postAuthRedirect";

const providerMap = {
  google: googleProvider,
  facebook: facebookProvider,
  apple: appleProvider,
};

export const useSocialAuth = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSocialAuth = async (providerName, role = "student") => {
    const provider = providerMap[providerName];
    if (!provider) return;

    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      // Send token + role to your backend
      const res = await api.post("/users/social-auth", { idToken, role });

      const { token, ...userData } = res.data;
      login(userData, token);
      toast.success(`Welcome, ${userData.firstName || userData.academyName}!`);

      // Reuse your existing role-based redirect logic
      setTimeout(() => {
        const redirectTo = consumePostAuthRedirect();
        if (redirectTo) return navigate(redirectTo);

        switch (userData.role) {
          case "student":   return navigate("/student-home");
          case "tutor":     return navigate("/tutor-home");
          case "institution": return navigate("/academy-home");
        //   case "admin":     return navigate("/admin/support");
          default:          return navigate("/");
        }
      }, 800);

    } catch (err) {
      // User closed the popup — don't show an error
      if (err.code === "auth/popup-closed-by-user") return;

      console.error(`[social-auth:${providerName}]`, err.code || err.message, err);

      if (err.code === "auth/operation-not-allowed") {
        toast.error(
          `${providerName[0].toUpperCase()}${providerName.slice(1)} sign-in isn't enabled yet. Please try another method.`,
        );
        return;
      }

      if (err.code === "auth/account-exists-with-different-credential") {
        toast.error(
          `An account already exists for ${err.customData?.email || "this email"} using a different sign-in method. Please use that method instead.`,
        );
        return;
      }

      if (err.code === "auth/popup-blocked") {
        toast.error("Your browser blocked the sign-in popup. Please allow popups and try again.");
        return;
      }

      const message = err?.response?.data?.message || "Social sign-in failed.";
      toast.error(message);
    }
  };

  return { handleSocialAuth };
};